import { render, staticRenderFns } from "./AlertMenu.vue?vue&type=template&id=6dc27fc6&scoped=true"
import script from "./AlertMenu.vue?vue&type=script&lang=js"
export * from "./AlertMenu.vue?vue&type=script&lang=js"
import style0 from "./AlertMenu.vue?vue&type=style&index=0&id=6dc27fc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc27fc6",
  null
  
)

export default component.exports